import { useId } from "react";

interface RotateDeviceIconProps {
  size?: number;
  colors?: [string, string];
}

/**
 * Screen-rotation glyph: portrait phone at ~45°, two curved arrows.
 * Stroke is a partner gradient (`dropzoneColors`) — SVG cannot paint
 * `whiteView.title`, which is a CSS `linear-gradient(...)` string.
 */
export const RotateDeviceIcon = ({
  size = 88,
  colors = ["currentColor", "currentColor"],
}: RotateDeviceIconProps) => {
  const gradientId = `rotate-device-stroke-${useId()}`;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
    >
      <defs>
        <linearGradient
          id={gradientId}
          x1="0"
          y1="0"
          x2="80"
          y2="80"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={colors[0]} />
          <stop offset="1" stopColor={colors[1]} />
        </linearGradient>
      </defs>
      <g
        stroke={`url(#${gradientId})`}
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g transform="rotate(45 40 40)">
          <rect x="27" y="16" width="26" height="48" rx="6.5" />
          <path d="M35 57h10" />
        </g>
        <path d="M44.2 10.3A30 30 0 0 0 10.3 35.8" />
        <path d="M15.3 30.6 10.3 35.8 6.9 29.4" />
        <path d="M35.8 69.7A30 30 0 0 0 69.7 44.2" />
        <path d="M64.7 49.4 69.7 44.2 73.1 50.6" />
      </g>
    </svg>
  );
};
